module.exports = __webpack_public_path__ + "img/Snipaste_2023-07-21_18-00-52.f9531cc8.png";